import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomeScreen } from './components/HomeScreen';
import { ConnectionScreen } from './components/ConnectionScreen';
import { FollowUpScreen } from './components/FollowUpScreen';
import { ProfileScreen } from './components/ProfileScreen';
import { DiscoveryScreen } from './components/DiscoveryScreen';
import { Navigation } from './components/Navigation';
export function App() {
  const [currentUser, setCurrentUser] = useState({
    id: 'u1',
    name: 'Alex Morgan',
    role: 'Product Manager',
    company: 'TechVision Inc.',
    tags: ['AI', 'Product Strategy', 'UX Design', 'SaaS'],
    goals: 'Looking for design partners and potential investors',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop'
  });
  return <div className="bg-indigo-50 min-h-screen w-full" data-id="element-0">
      <Router data-id="element-1">
        <div className="max-w-md mx-auto bg-white min-h-screen flex flex-col shadow-lg" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<HomeScreen user={currentUser} data-id="element-5" />} data-id="element-4" />
            <Route path="/connection/:id" element={<ConnectionScreen user={currentUser} data-id="element-7" />} data-id="element-6" />
            <Route path="/follow-up" element={<FollowUpScreen data-id="element-9" />} data-id="element-8" />
            <Route path="/profile" element={<ProfileScreen user={currentUser} setUser={setCurrentUser} data-id="element-11" />} data-id="element-10" />
            <Route path="/discovery" element={<DiscoveryScreen data-id="element-13" />} data-id="element-12" />
          </Routes>
          <Navigation data-id="element-14" />
        </div>
      </Router>
    </div>;
}